import { Box } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import useEmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters/hooks/useEmployeeMultiFilters'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import getFilterValue from 'modules/shift_management/components/ShiftManagement/Content/_filters/getFilterValue'
import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import { SHIFT_MANAGEMENT_FILTERS } from 'modules/shift_management/hooks/reducers/filter'
import useLocationOptions from 'modules/shift_management/hooks/useLocationOptions'

interface Props {
  locationField: Field
  setDisableSubmit: (state: boolean) => void
}
const Content = observer(({ locationField, setDisableSubmit }: Props) => {
  const { locationOptions } = useLocationOptions({
    locationField,
  })
  const { filters } = useEmployeeMultiFilters(getFilterValue, LOCAL_STORAGE_KEYS.shiftEmployees)

  useUnsafeEffect(() => {
    const locationFilter =
      filters?.filter((f) => f.values.field === SHIFT_MANAGEMENT_FILTERS.employeeLocation) || []

    if (locationFilter.length === 1) {
      locationField.set(locationFilter.at(0)?.values?.value || '')
      setDisableSubmit(false)
    } else {
      locationField.set('')
      setDisableSubmit(true)
    }
  }, [filters])

  return (
    <Box gap="s16" flexDirection="row" justifyContent="center" alignItems="center">
      <TooltipIcon.Medium
        icon="pin"
        label={i18n.t('shift_management.actions_sidepanel.tooltip.workplace')}
        color="grey700"
      />
      <Box width="full">
        <DropdownSearchBar
          searchLabel={i18n.t('common.search')}
          sortLabel={i18n.t('common.name')}
          selectLabel={i18n.t('common.select')}
          labelNotFound={i18n.t('common.select')}
          label={''}
          data={locationOptions}
          name={
            locationOptions.find(
              (option) => option.value.toString() === locationField.value.toString()
            )?.label || i18n.t('common.select')
          }
          onSelect={(option) => {
            locationField.set(option.value)
            setDisableSubmit(false)
          }}
          autofocus={false}
        />
      </Box>
    </Box>
  )
})

export { Content }
